import styled from 'styled-components';
export const StyledScrolledAttributeItem = styled.div `
  display: inline-block;
`;
//# sourceMappingURL=styles.js.map